import { BaseModel, fillOwnProperties, registerModel } from '~/shared/model'
import { isNonEmptyString, isUnknownObject } from '~/shared/utils/guards'
import { toMonthAndYear } from '~/shared/utils/date'

export default class ResumeCardExperience extends BaseModel {
  static override constructorName = 'ResumeCardExperienceModel'

  position: string = ''
  'job_facility': string = ''
  'start_date': string = ''
  'end_date': string = ''
  period: string = ''

  constructor(data?: unknown) {
    super(data)

    if (!isUnknownObject(data)) {
      return
    }

    fillOwnProperties(this, data, ['period'])

    if (isNonEmptyString(data.start_date)) {
      const month = toMonthAndYear(data.start_date)
      this.start_date = month.charAt(0).toUpperCase() + month.slice(1)
    }

    if (isNonEmptyString(data.end_date)) {
      this.end_date = toMonthAndYear(data.end_date)
    }

    if (this.start_date && this.end_date) {
      this.period = `${this.start_date} - ${this.end_date}`
    }
  }
}

registerModel(ResumeCardExperience)
